import React, { useRef } from 'react';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Switch } from './ui/switch';

const InscriptionEditor = React.memo(({
  text,
  onTextChange,
  autoConvert,
  onAutoConvertChange,
  fontSize,
  language,
}) => {
  const textareaRef = useRef(null);
  const convert = language?.convert;
  const fontClass = language?.fontClass || 'font-hebrew';
  const autoConvertLabel =
    language?.autoConvertLabel || 'Auto-convert English → Hebrew';
  const rtlLabel = language?.rtlLabel || 'Right-to-Left';
  const placeholder = language?.placeholder || 'Begin typing your inscription';

  const handleKeyPress = (e) => {
    if (autoConvert && convert && e.key.length === 1) {
      e.preventDefault();
      const converted = convert(e.key);
      const start = e.target.selectionStart;
      const end = e.target.selectionEnd;
      const newText =
        text.substring(0, start) + converted + text.substring(end);
      onTextChange(newText);
      setTimeout(() => {
        if (textareaRef.current) {
          textareaRef.current.selectionStart = start + converted.length;
          textareaRef.current.selectionEnd = start + converted.length;
        }
      }, 0);
    }
  };

  return (
    <div className="space-y-4">
      {/* Auto-convert toggle */}
      <div className="flex items-center justify-between border-b border-stone-100 pb-3">
        <div className="flex items-center gap-3">
          <Switch
            id="auto-convert"
            checked={autoConvert}
            onCheckedChange={onAutoConvertChange}
            data-testid="auto-convert-toggle"
          />
          <Label
            htmlFor="auto-convert"
            className="uppercase tracking-[0.18em] text-[11px] font-semibold text-stone-500 cursor-pointer"
          >
            {autoConvertLabel}
          </Label>
        </div>
      </div>

      {/* Inscription textarea */}
      <div className="space-y-2">
        <Textarea
          id="inscription-text"
          ref={textareaRef}
          value={text}
          onChange={(e) => onTextChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          className={`min-h-[280px] w-full ${fontClass} leading-relaxed resize-none border border-stone-200 rounded-sm bg-stone-50/40 focus-visible:ring-1 focus-visible:ring-stone-900 focus-visible:ring-offset-0 focus-visible:border-stone-900 text-center placeholder:text-stone-300 placeholder:font-spectral placeholder:font-light placeholder:text-lg transition-colors duration-200`}
          dir="rtl"
          style={{ fontSize: `${fontSize}px` }}
          data-testid="inscription-textarea"
        />
        <div className="flex items-center justify-between text-[11px] uppercase tracking-[0.18em] font-semibold text-stone-400 pt-1">
          <span data-testid="char-count">{text.length} characters</span>
          <span>{rtlLabel}</span>
        </div>
      </div>
    </div>
  );
});

InscriptionEditor.displayName = 'InscriptionEditor';

export default InscriptionEditor;
